module.exports = __webpack_public_path__ + "eating.392cdf3b.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/eating.png
// module id = 483
// module chunks = 0